export const EMPLOYEE_LOGOUT_WARNING =
  "Hvis du logger ud, skal din chef sende dig et nyt invitationslink, før du kan bruge AppSmeden på denne enhed igen. Vil du fortsætte?";

export function confirmEmployeeLogout(): boolean {
  return window.confirm(EMPLOYEE_LOGOUT_WARNING);
}
